import { FunctionComponent, useEffect, useState } from 'react';
import { Text } from '@primer/react';
import { usePlayers } from '../../hooks/usePlayers';
import { GameBoard } from '../gameBoard/GameBoard';
import { useAppSelector } from '../../redux/hooks';
import { getGameState } from '../../redux/slices/game.slice';
import { useGetRoomQuery } from '../../redux/apis/rooms';
import spaceC from '../../images/board/space-C.svg';
import spaceJ from '../../images/board/space-J.svg';
import spaceLIGHT from '../../images/board/space-LIGHT.svg';
import spaceRJR from '../../images/board/space-RJR.svg';
import spaceRM from '../../images/board/space-RM.svg';
import spaceCJ from '../../images/board/space-CJ.svg';
import spaceCR from '../../images/board/space-CR.svg';
import spaceCJR from '../../images/board/space-CJR.svg';
import spaceJR from '../../images/board/space-JR.svg';
import animation from '../../images/board/CJR-animation.json'
import { getDecksForStep } from './stepsConfig';
import Lottie from 'react-lottie';
import { DeckType } from '../../redux/models/colyseumSchemas/Deck';

const getStepSymbolForDecks = (decks: DeckType[]) => {
  if (decks.length == 1) {
    if (decks.includes("cozy")) return spaceC;
    if (decks.includes("juicy")) return spaceJ;
    if (decks.includes("random")) return spaceRM;
    if (decks.includes("lightning")) return spaceLIGHT;
  }
  if (decks.length == 2) {
    if (decks.includes("cozy") && decks.includes("juicy")) return spaceCJ;
    if (decks.includes("real") && decks.includes("juicy")) return spaceJR;
    if (decks.includes("cozy") && decks.includes("real")) return spaceCR;
  }
  if (decks.length == 3) {
    if (decks.includes("cozy") && decks.includes("juicy") && decks.includes("real")) return spaceCJR;
    if (decks.includes("random") && decks.includes("juicy") && decks.includes("real")) return spaceRJR;
  }
  return spaceCJ;
};

export const ScorePhase: FunctionComponent = () => {
  const { turnPlayer, isPlayerTurn, nextPlayer } = usePlayers();
  const { pointsThisTurn = 0, stepsThisTurn = 0, room } = useAppSelector(getGameState);
  const getRoom = useGetRoomQuery(room!.id);

  const [diceSteps, setDiceSteps] = useState(0);
  const [space, setSpace] = useState('');

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  useEffect(() => {
    setSpace('')
  }, []);

  useEffect(() => {
    let num = 0;
    const interval = setInterval(() => {
      setDiceSteps(num);
      num++;
      if (num > 6) num = 0;
    }, 50);
    setTimeout(() => {
      clearInterval(interval);
      setDiceSteps(stepsThisTurn);
      setSpace(getStepSymbolForDecks(getDecksForStep(nextPlayer.steps)));
    }, getRoom.data?.simpleGame ? 2800 : 2000);
  }, [stepsThisTurn]); 

  const who = isPlayerTurn ? 'You' : turnPlayer?.nickname;
  return (
    <GameBoard noBoard={getRoom.data ? getRoom.data.simpleGame : true}>
      <img src={spaceC} style={{ display: 'none' }}/>
      <img src={spaceJ} style={{ display: 'none' }}/>
      <img src={spaceLIGHT} style={{ display: 'none' }}/>
      <img src={spaceRJR} style={{ display: 'none' }}/>
      <img src={spaceRM} style={{ display: 'none' }}/>
      <img src={spaceCJ} style={{ display: 'none' }}/>
      <img src={spaceCR} style={{ display: 'none' }}/>
      <img src={spaceCJR} style={{ display: 'none' }}/>
      <img src={spaceJR} style={{ display: 'none' }}/>

      {stepsThisTurn > 0 ? (
        <>
          <Text
            as="p"
            sx={{
              maxWidth: '200px',
              width: '80%',
              borderRadius: '15px',
              border: '2px dashed #009B88',
              padding: '18px',
              background: '#FFF',
              fontSize: '14px',
              lineHeight: '22px',
              fontWeight: 600,
            }}
            textAlign="center"
          >
            { getRoom.data?.simpleGame ? 
              (<>{'Shuffling your card decks!'}</>) :
              (<>{`${who} get${isPlayerTurn ? '' : 's'} ${pointsThisTurn} points and move${
                isPlayerTurn ? '' : 's'
              } `}
              <span
                style={{ fontFamily: 'monospace', fontSize: '20px', color: 'red' }}
              >{`${diceSteps}`}</span>
              {` space${stepsThisTurn > 1 ? 's' : ''}!`}</>)
            }
            <br/>
          { getRoom.data?.simpleGame ? 
            (<>
              { space ? <img src={space} style={{ width: '90px', marginTop: '10px' }}/> 
              : <Lottie 
                options={defaultOptions}
                  height={110}
                  width={110}
                />}
            </>) : null }
          </Text>
        </>
      ) : null}
    </GameBoard>
  );
};
